window.ttlRewriteDurationLabel = function (text) {
  var s = String(text == null ? "" : text);
  if (!s) return s;
  var lang = ((document.documentElement && document.documentElement.lang) || "fr").slice(0, 2);
  function pack(n) {
    n = parseInt(n, 10) || 1;
    if (lang === "de") return n === 1 ? "1 Serum" : n + " Seren";
    if (lang === "en") return n === 1 ? "1 serum" : n + " serums";
    return n === 1 ? "1 sérum" : n + " sérums";
  }
  function subEvery(n) {
    n = parseInt(n, 10) || 1;
    if (lang === "de") return n === 1 ? "Jeden Monat" : "Alle " + n + " Monate";
    if (lang === "en") return n === 1 ? "Every month" : "Every " + n + " months";
    return n === 1 ? "Tous les mois" : "Tous les " + n + " mois";
  }
  var subs = [];
  s = s.replace(/livraison\s+tous\s+les\s+(\d+)\s+(jours|days?)/gi, function (_, d) {
    var days = parseInt(d, 10) || 0;
    var months = days === 30 ? 1 : days === 90 ? 3 : days === 180 ? 6 : Math.round(days / 30) || 1;
    subs.push(subEvery(months));
    return "%%TTL_SUB" + (subs.length - 1) + "%%";
  });
  s = s.replace(/livraison\s+tous\s+les\s+(\d+)\s*(mois|months?|Monate?)/gi, function (_, n) {
    subs.push(subEvery(n));
    return "%%TTL_SUB" + (subs.length - 1) + "%%";
  });
  s = s.replace(/tous\s+les\s+(\d+)\s*(mois|months?|Monate?)/gi, function (_, n) {
    subs.push(subEvery(n));
    return "%%TTL_SUB" + (subs.length - 1) + "%%";
  });
  s = s.replace(/tous\s+les\s+(mois|months?)\b/gi, function () {
    subs.push(subEvery(1));
    return "%%TTL_SUB" + (subs.length - 1) + "%%";
  });
  s = s.replace(/cure\s+de\s+/gi, "Cure ");
  s = s.replace(/\b(\d+)\s*(mois|months?|Monate?)\b/gi, function (_, n) {
    return pack(n);
  });
  s = s.replace(/\bx(\d+)\s*[- ]?month(?:s)?(?:\s+supply)?\b/gi, function (_, n) {
    return pack(n);
  });
  s = s.replace(/%%TTL_SUB(\d+)%%/g, function (_, i) {
    return subs[parseInt(i, 10)] || "";
  });
  return s;
};

function looksSelection(e) {
    var o, n;
    for (o = document.getElementsByClassName("naturalLooks"), n = 0; n < o.length; n++) w3RemoveClass(o[n], "show"), o[n].className.indexOf(e) > -1 && w3AddClass(o[n], "show")
}

function filterSelection(e) {
    var o, n;
    for (o = document.getElementsByClassName("filterDiv"), n = 0; n < o.length; n++) w3RemoveClass(o[n], "show"), o[n].className.indexOf(e) > -1 && w3AddClass(o[n], "show")
}

function w3AddClass(e, o) {
    var n, t, a;
    for (t = e.className.split(" "), a = o.split(" "), n = 0; n < a.length; n++) - 1 == t.indexOf(a[n]) && (e.className += " " + a[n])
}

function w3RemoveClass(e, o) {
    var n, t, a;
    for (t = e.className.split(" "), a = o.split(" "), n = 0; n < a.length; n++)
        for (; t.indexOf(a[n]) > -1;) t.splice(t.indexOf(a[n]), 1);
    e.className = t.join(" ")
}

$(document).ready(function() {
    $("#home-carousel").owlCarousel({
        loop: !0,
        center: !1,
        dots: !0,
        autoWidth: !1,
        autoplay: !0,
        lazyLoad: !0,
        autoplayTimeout: 3e3,
        autoplayHoverPause: !1,
        responsiveClass: !0,
        navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
        responsive: {
            0: {
                items: 2,
                dotsEach: 1,
                nav: !0
            },
            600: {
                items: 2,
                dotsEach: 1,
                nav: !1
            },
            1000: {
                items: 6,
                dotsEach: 1,
                nav: !0
            }
        }
    }), $("#eye__shape__guide-container").owlCarousel({
        loop: !0,
        center: !1,
        dots: !1,
        autoWidth: !1,
        autoplay: !1,
        lazyLoad: !0,
        autoplayTimeout: 3e3,
        autoplayHoverPause: !1,
        responsiveClass: !0,
        responsive: {
            0: {
                items: 1,
                nav: !0
            },
            600: {
                items: 2,
                nav: !1
            },
            1000: {
                items: 2,
                nav: !0
            }
        }
    }), $().fancybox()
}), $(document).ready(function() {
    $("body").on("click", ".accordion-toggle", function(e) {
        e.preventDefault();
        var o = $(this),
            n = o.next(".accordion-content");
        o.toggleClass("open"), n.slideToggle(250)
    }), $("#accordion-first a:first").trigger("click")
}), $(document).ready(function() {
    $(".tabs-nav a").on("click", function(e) {
        e.preventDefault(), $(".tab-active").removeClass("tab-active"), $(this).parent().addClass("tab-active"), $(".tabs-stage .tabs-stage__item").hide(), $($(this).attr("href")).show()
    }), $(".tabs-nav a:first").trigger("click")
}), filterSelection("Looks");
var btnContainer = document.getElementById("myBtnContainer");
if (btnContainer)
    for (var btns = btnContainer.getElementsByClassName("btn"), i = 0; i < btns.length; i++) btns[i].addEventListener("click", function() {
        var e = document.getElementsByClassName("active");
        e[0].className = e[0].className.replace(" active", ""), this.className += " active"
    });
$(document).ready(function() {
    var e = $("#saleSlider"),
        o = $(".sale-slider-wrapper");
    e.slick({
        dots: !1,
        arrows: !1,
        infinite: !0,
        autoplay: !0,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }, {
            breakpoint: 800,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    }), o.show(), e.show()
    $('.hpy_customer_slider').slick({
      infinite: true,
      slidesToShow: 1,
      arrows: false,
      dots: true, 
      slidesToScroll: 1, 
    });
// }), $(document).ready(function() {
//     $(window).scroll(function() {    
//         var scroll = $(window).scrollTop();
//         if (scroll >= 300) {
//           $("#shopify-section-header").addClass("stopontop");
//           $(".shopify-section.announcement-bar-section").addClass("show_annonce")
//         }else{
//           $("#shopify-section-header").removeClass("stopontop");
//           $(".shopify-section.announcement-bar-section").removeClass("show_annonce")
//         }
//     });
    jQuery(".faq_js").detach().appendTo(".faq_insert"), $("body").on("click", ".custom_cart_link", function() {
        if ("/cart" === top.location.pathname || "/cart/" === top.location.pathname) return location.reload(), !1;
        $(".cart_container").addClass("active_link"), $(".you_may_like_content .ajax-submit").not(".add_to_cart_mobile").removeClass("action_button")
    }), (function() {
        function closeMiniCart(e) {
            if ($(e.target).closest(".cart_heading_close").length === 0 && window.ttlCartCro && typeof window.ttlCartCro.bogosGuarded === "function" && window.ttlCartCro.bogosGuarded()) {
                return;
            }
            $(".cart_container").removeClass("active_link"), $("body").removeClass("blocked-scroll")
        }
        $("body").on("pointerup", ".cart_heading_close", function(e) {
            if (e.pointerType === "mouse" && e.button !== 0) return;
            e.preventDefault();
            e.stopPropagation();
            closeMiniCart(e);
        });
        $("body").on("click", ".cart_container_back, .cart_heading_close", function(e) {
            if ($(this).is(".cart_heading_close") && e.originalEvent && e.originalEvent.pointerType) return;
            closeMiniCart(e);
        });
    })(), $("body").on("click", ".show_search", function(e) {
        e.preventDefault();
        var $btn = $(this);
        var $mobile = $btn.closest(".mobile_search");
        if ($mobile.length) {
            $mobile.addClass("open");
            $mobile.find(".new_search").hide();
            $mobile.find(".new_search_input").addClass("open");
            $mobile.find(".close_search").addClass("open");
            $("#header .mobile_logo").addClass("hidden_logo");
            $("body").addClass("ttl-mobile-search-open");
            var mobileInput = $mobile.find(".new_search_input input[name='q']").get(0);
            if (mobileInput) {
                mobileInput.focus();
            }
            return;
        }
        var $item = $btn.closest(".new_search");
        var $wrap = $item.nextAll(".new_search_input").first();
        $item.hide();
        $wrap.addClass("open");
        $wrap.find(".close_search").addClass("open");
        $(".main__logo").addClass("hidden_logo");
        var desktopInput = $wrap.find("input[name='q']").get(0);
        if (desktopInput) {
            desktopInput.focus();
        }
    }), $("body").on("click", ".close_search", function(e) {
        e.preventDefault();
        var $btn = $(this);
        var $mobile = $btn.closest(".mobile_search");
        if ($mobile.length) {
            $mobile.removeClass("open");
            $mobile.find(".new_search_input").removeClass("open");
            $mobile.find(".close_search").removeClass("open");
            $mobile.find(".new_search").show();
            $("#header .mobile_logo").removeClass("hidden_logo");
            $("body").removeClass("ttl-mobile-search-open");
            return;
        }
        var $wrap = $btn.closest(".new_search_input");
        $wrap.removeClass("open");
        $wrap.find(".close_search").removeClass("open");
        $wrap.prevAll(".new_search").first().show();
        $(".main__logo").removeClass("hidden_logo");
    }), $(".shopify-section.slideshow-section").length > 0 && $(window).scroll(function() {
        $(document).scrollTop() > $(".shopify-section.slideshow-section").height() + $(".shopify-section.slideshow-section").offset().top ? 
          $(".shopify-section.announcement-bar-section").addClass("hide_annonce") : 
          $(".shopify-section.announcement-bar-section").removeClass("hide_annonce")
    }), /* window.onload = function() {
        var e = document.title,
            o = "🔥 Un regard parfait c’est maintenant!",
            // o = "🔥 Hurry! Items Selling Fast",
            n = null;
        document.addEventListener("visibilitychange", function(t) {
            !document.hidden ? (document.title = e, clearInterval(n)) : n = setInterval(function() {
                document.title === o ? document.title = e : document.title = o
            }, 100)
        })
    }, */ $("body").on("click", ".popup_announce", function(e) {
        $(".popup_announce_back, .popup_announce_content").addClass("open")
    }), $("body").on("click", ".popup_announce_back, .close_popup_announce", function(e) {
        $(".popup_announce_back, .popup_announce_content").removeClass("open")
    }), 
    $("body").on("click", ".you_may_like_button", function() {
        var wrapper = $(this).closest(".you_may_like");
        var content = wrapper.find(".you_may_like_content");
        $(this).toggleClass("active");
        content.toggleClass("active");

        $(".you_may_like .slider-gallery.products-slider").flickity("destroy"), 
        $(".you_may_like .slider-gallery.products-slider").flickity({
            lazyLoad: 2,
            imagesLoaded: !0,
            draggable: !0,
            cellAlign: "left",
            prevNextButtons: !1,
            wrapAround: !1,
            pageDots: !0,
            contain: !0,
            freeScroll: !1
        })
    }), 
    $("body").on("click", ".open_filters", function(e) {
        $(".collection .sidebar, .open_filters_back").addClass("open"), $("body").addClass("blocked-scroll2")
    }), $("body").on("click", ".open_filters_back, .close_filter", function(e) {
        $(".collection .sidebar, .open_filters_back").removeClass("open"), $("body").removeClass("blocked-scroll2")
    }), $("body").on("click", ".quantity_button", function(e) {
        $(".quantity_button").toggleClass("active")
    })
// }), $(document).ready(function() {
//     var e = 0,
//         o = $(".promo_banner.bg-black").height(),
//         n = $(".new_sticky_header").height();
//     $(window).scroll(function(t) {
//         var a = $(this).scrollTop();
//         a < n ? $("#shopify-section-anouncement-bar").removeClass("hide_annonce") : $("#shopify-section-anouncement-bar").addClass("hide_annonce"), a < o ? $(".promo_banner.bg-black").css({
//             position: "sticky",
//             top: 0,
//             transition: "all .2s ease-in-out"
//         }) : $(".promo_banner.bg-black").css({
//             position: "sticky",
//             top: -o,
//             transition: "all 0s ease-in-out"
//         }), a > o ? a > e ? $(".new_sticky_header").css({
//             position: "sticky",
//             top: -n + o
//         }) : $(".new_sticky_header").css({
//             position: "sticky",
//             top: 0
//         }) : $(".new_sticky_header").css({
//             position: "sticky",
//             top: -n
//         }), e = a
//     })
}), $(document).ready(function() {
    var lastScroll = 0;
    $(window).scroll(function() {
        var currentScroll = $(this).scrollTop();
        var announceBar = $("#shopify-section-anouncement-bar");
        var announceHeight = announceBar.outerHeight() || 0;

        // Scroll vers le bas = cacher l'announcement bar
        if (currentScroll > lastScroll && currentScroll > announceHeight) {
            announceBar.addClass("hide_annonce");
            $(".new_sticky_header").css("top", -announceHeight + "px");
        }
        // Scroll vers le haut = montrer l'announcement bar
        else {
            announceBar.removeClass("hide_annonce");
            $(".new_sticky_header").css("top", "0px");
        }

        lastScroll = currentScroll;
    });
}), $("body").on("click", ".pink_points", function(e) {
    $(".magnetic_pionts_popup").fadeIn()
}), $("body").on("click", ".close-popup", function(e) {
    $(".magnetic_pionts_popup").fadeOut()
}), $(document).mouseup(function(e) {
    var o = $(".popup-content");
    e.target != o[0] && 0 === o.has(e.target).length && $(".magnetic_pionts_popup").fadeOut()
});
var waitForEl = function(e, o) {
    jQuery(e).length ? o() : setTimeout(function() {
        waitForEl(e, o)
    }, 100)
};
waitForEl(".hulkapps_option_value select", function() {
    $(".hulkapps_option_value select option:first-of-type").text("SÉLECTION")
});

$(document).ready(function(){
    let mutationObserver = new MutationObserver(function(mutations) {
      // $('.slider-gallery').flickity('resize')
    });
    mutationObserver.observe(document.documentElement, {
      childList: true,
    });
  });



$(document).ready(function() {
      $('.review-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="27" height="12" viewBox="0 0 27 12" fill="none"> <path d="M0.469669 6.53033C0.176777 6.23744 0.176777 5.76257 0.469669 5.46967L5.24264 0.696701C5.53553 0.403808 6.01041 0.403808 6.3033 0.696701C6.59619 0.989594 6.59619 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.59619 10.5355 6.59619 11.0104 6.3033 11.3033C6.01041 11.5962 5.53553 11.5962 5.24264 11.3033L0.469669 6.53033ZM27 6.75L1 6.75L1 5.25L27 5.25L27 6.75Z" fill="#282828"/></svg></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="27" height="12" viewBox="0 0 27 12" fill="none"> <path d="M26.5303 6.53033C26.8232 6.23744 26.8232 5.76257 26.5303 5.46967L21.7574 0.696701C21.4645 0.403808 20.9896 0.403808 20.6967 0.696701C20.4038 0.989594 20.4038 1.46447 20.6967 1.75736L24.9393 6L20.6967 10.2426C20.4038 10.5355 20.4038 11.0104 20.6967 11.3033C20.9896 11.5962 21.4645 11.5962 21.7574 11.3033L26.5303 6.53033ZM-6.55671e-08 6.75L26 6.75L26 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z" fill="#282828"/></svg></button>',
        responsive: [
    {
      breakpoint:768,
      settings: {
        arrows: false,
        dots: true
      }
    },
        ]
    });
  
  $(window).scroll(function() {
    var announce_height = $('.announcement-bar-section.hide_annonce').outerHeight() - 2;
    $('.new_sticky_header .header-section').css('top' , announce_height)
  });
  
});

$(document).ready(function() {
  $(document).on("click", ".storelangmob .dropbtn", function(e) {
    e.preventDefault();
    e.stopPropagation();
    var $content = $(this).siblings(".store_dropdown_content");
    var isOpen = $content.hasClass("is-open");
    $(".storelangmob .store_dropdown_content").removeClass("is-open").hide();
    if (!isOpen) {
      $content.addClass("is-open").show();
    }
  });

  $(document).on("click", function(event) {
    if (!$(event.target).closest(".storelangmob .store_dropdown").length) {
      $(".storelangmob .store_dropdown_content").removeClass("is-open").hide();
    }
  });
});



// Destroy the first slider
$(document).ready(function() {
  // Initialize the first slider
  $('.slider-nouveautés .slider-gallery').flickity('destroy');
  $('.slider-nouveautés .slider-gallery').flickity({
    lazyLoad: 2,
    imagesLoaded: true,
    draggable: true,
    cellAlign: 'left',
    prevNextButtons: true,
    wrapAround: false,  // Disable infinite scroll
    pageDots: false,
    contain: true,
    freeScroll: false
  }).on('ready.flickity', function() {
    console.log('Slider initialized for slider-nouveautés');
  });

    // Initialize the first slider
  $('.slider-pourvoscils .slider-gallery').flickity('destroy');
  $('.slider-pourvoscils .slider-gallery').flickity({
    lazyLoad: 2,
    imagesLoaded: true,
    draggable: true,
    cellAlign: 'left',
    prevNextButtons: true,
    wrapAround: false,  // Disable infinite scroll
    pageDots: false,
    contain: true,
    freeScroll: false
  }).on('ready.flickity', function() {
    console.log('Slider initialized for slider-pourvoscils');
  });

      // Initialize the first slider
  $('.slider-pourvoscheveux .slider-gallery').flickity('destroy');
  $('.slider-pourvoscheveux .slider-gallery').flickity({
    lazyLoad: 2,
    imagesLoaded: true,
    draggable: true,
    cellAlign: 'left',
    prevNextButtons: true,
    wrapAround: false,  // Disable infinite scroll
    pageDots: false,
    contain: true,
    freeScroll: false
  }).on('ready.flickity', function() {
    console.log('Slider initialized for slider-pourvoscheveux');
  });
  
  // Initialize the second slider
  $('.slider-nosproduits .slider-gallery').flickity('destroy');
  $('.slider-nosproduits .slider-gallery').flickity({
    lazyLoad: 2,
    imagesLoaded: true,
    draggable: true,
    cellAlign: 'left',
    prevNextButtons: true,
    wrapAround: false, // This disables infinite scrolling
    pageDots: false,
    contain: true,
    freeScroll: false
  }).on('ready.flickity', function() {
    console.log('Slider initialized for slider-nosproduits');
  });

    // Initialize the third slider
  $('.slider-tothehair .slider-gallery').flickity('destroy');
  $('.slider-tothehair .slider-gallery').flickity({
    lazyLoad: 2,
    imagesLoaded: true,
    draggable: true,
    cellAlign: 'left',
    prevNextButtons: true,
    wrapAround: false, // This disables infinite scrolling
    pageDots: false,
    contain: true,
    freeScroll: false
  }).on('ready.flickity', function() {
    console.log('Slider initialized for slider-tothehair');
  });
});

$(document).ready(function () {
  // Show the popup when a button is clicked
  $(document).on('click', '.sold_out_waitlist', function () {
    $('.waitlistpopup').fadeIn();
  });

  // Close the popup when the close button is clicked
  $(document).on('click', '.waitlist-close', function () {
    $('.waitlistpopup').fadeOut();
  });

  // Close the popup when clicking outside the popup content
  $(document).on('click', '.waitlistpopup', function (event) {
    if (!$(event.target).closest('.waitlist-popbox').length) {
      $('.waitlistpopup').fadeOut();
    }
  });
});


  document.addEventListener("DOMContentLoaded", function () {
    const maxAttempts = 20;
    let attempts = 0;

    const forceTrueX1Selection = () => {
      const x1Label = document.querySelector('label[for="swatch-0-x1-serum-8298302112079-product-template"]');
      if (x1Label) {
        x1Label.click(); // this triggers both UI + functional update
      }

      attempts++;
      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    };

    const interval = setInterval(forceTrueX1Selection, 300);
  });


(function () {
  if (window.__ttlKlaviyoDrawerGuard) return;
  window.__ttlKlaviyoDrawerGuard = true;

  var OPEN_CLASS = "ttl-cart-drawer-open";
  var HELD_ATTR = "data-ttl-klaviyo-held";
  var popupObserver = null;
  var formsHeld = false;

  function isDrawerOpen() {
    return !!document.querySelector(".cart_container.active_link");
  }

  function klaviyoCall(method) {
    var args = Array.prototype.slice.call(arguments, 1);
    var k = window.klaviyo;
    try {
      if (k && typeof k[method] === "function") {
        k[method].apply(k, args);
        return;
      }
    } catch (e) {}
    if (k && typeof k.push === "function") {
      k.push([method].concat(args));
      return;
    }
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push([method].concat(args));
  }

  function isEmbeddedKlaviyo(el) {
    return !!(el.closest && el.closest("footer, .footer, .newsletter, .password-page-col, #password-container, .cart_content"));
  }

  function findFixedKlaviyoRoot(el) {
    if (isEmbeddedKlaviyo(el)) return null;
    var root = null;
    var node = el;
    while (node && node !== document.body && node !== document.documentElement) {
      if (window.getComputedStyle(node).position === "fixed") root = node;
      node = node.parentElement;
    }
    return root;
  }

  function hideKlaviyoPopups() {
    var nodes = document.querySelectorAll('[class*="klaviyo-form"], [class*="kl-private-reset-css"]');
    for (var i = 0; i < nodes.length; i++) {
      var root = findFixedKlaviyoRoot(nodes[i]);
      if (!root || root.getAttribute(HELD_ATTR)) continue;
      root.setAttribute(HELD_ATTR, "");
    }
  }

  function restoreKlaviyoPopups() {
    var held = document.querySelectorAll("[" + HELD_ATTR + "]");
    for (var i = 0; i < held.length; i++) {
      held[i].removeAttribute(HELD_ATTR);
    }
  }

  function startPopupWatch() {
    if (popupObserver || !document.body) return;
    popupObserver = new MutationObserver(hideKlaviyoPopups);
    popupObserver.observe(document.body, { childList: true, subtree: true });
    hideKlaviyoPopups();
  }

  function stopPopupWatch() {
    if (popupObserver) {
      popupObserver.disconnect();
      popupObserver = null;
    }
    restoreKlaviyoPopups();
  }

  function sync() {
    var open = isDrawerOpen();
    document.documentElement.classList.toggle(OPEN_CLASS, open);
    if (open) {
      if (!formsHeld) {
        klaviyoCall("disableForms");
        formsHeld = true;
      }
      startPopupWatch();
    } else if (formsHeld) {
      stopPopupWatch();
      klaviyoCall("enableForms");
      formsHeld = false;
    }
  }

  window.addEventListener("klaviyoForms", function (e) {
    if (!e.detail || e.detail.type !== "open") return;
    if (!isDrawerOpen()) return;
    document.documentElement.classList.add(OPEN_CLASS);
    hideKlaviyoPopups();
  });

  var classObserver = new MutationObserver(sync);

  function observeDrawers() {
    var containers = document.querySelectorAll(".cart_container");
    for (var i = 0; i < containers.length; i++) {
      classObserver.observe(containers[i], { attributes: true, attributeFilter: ["class"] });
    }
    sync();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeDrawers);
  } else {
    observeDrawers();
  }
})();

document.addEventListener("DOMContentLoaded", function() {
    // Map of variant IDs to image URLs
    const variantImages = {
      "48109382173007": "https://cdn.shopify.com/s/files/1/0555/8753/7231/files/offer-frame-2.png?v=1758789142",
      "48109382140239": "https://cdn.shopify.com/s/files/1/0555/8753/7231/files/offer-frame-1.png?v=1758788926",
      "54600728019279": "https://cdn.shopify.com/s/files/1/0555/8753/7231/files/offer-frame-2.png?v=1758789142",
      "54600727986511": "https://cdn.shopify.com/s/files/1/0555/8753/7231/files/offer-frame-1.png?v=1758788926"
    };

    // Select all swatch elements
    const swatches = document.querySelectorAll('.swatch-element');

    swatches.forEach(swatch => {
      swatch.addEventListener('click', function() {
        const variantId = swatch.getAttribute('data-id');
        if (variantImages[variantId]) {
          document.getElementById('offerImage').src = variantImages[variantId];
        }
      });
    });
  });

window.ttlPushAtc = function (btn) {
  if (!btn) return;
  var root = btn.closest("[data-product-form]") || btn.closest("form");
  var form = btn.closest("form") || (root && root.querySelector("form"));
  var idEl = form && form.querySelector("[name='id']");
  var variantId = (idEl && idEl.value) || btn.getAttribute("data-var-id") || "";
  var product = {};
  try {
    product = JSON.parse((root && root.getAttribute("data-product")) || "{}");
  } catch (e) {}
  var variant = null;
  var variants = product.variants || [];
  for (var i = 0; i < variants.length; i++) {
    if (String(variants[i].id) === String(variantId)) {
      variant = variants[i];
      break;
    }
  }
  var price = variant ? variant.price / 100 : 0;
  var currency = (root && root.getAttribute("data-shop-currency")) || "";
  var category = (root && root.getAttribute("data-ttl-atc-category")) || "";
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "add_to_cart",
    "atc.revenue": price,
    "atc.currency": currency,
    "atc.product_id": String(product.id || ""),
    "atc.variant_id": String(variantId),
    "atc.variant_title": variant ? variant.title : "",
    "atc.item_name": product.title || "",
    "atc.product_category": category,
  });
};

// custom-js file